import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class TwoFactorAuthRecoveryResource {
  private readonly verifiers = ApiConfig.obtain().getVersionedUri('2fa');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  getRecoveryUsers(userId: string, networkId: string) {
    return this.send({
      method: 'GET',
      url: this.verifiers + "/recovery/verifiers/" + userId,
      params: {context: networkId}
    }).catch(function() {
      return null;
    });
  }

  getVerifyingUsers(userId: string) {
    return this.send({
      method: 'GET',
      url: this.verifiers + "/recovery/verifying/" + userId
    }).catch(function() {
      return null;
    });
  }

  getRecoveryUser(userId: string) {
    return this.send({
      method: 'GET',
      url: this.verifiers + "/recovery/user/" + userId
    }).catch(function(response) {
      return response;
    });
  }

  submitVerifyUser(userId: string, verifyUserId: string, networkId: string) {
    const data = {'recoveryUser': userId, 'verifyUser': verifyUserId};
    return this.send({
      method: 'POST',
      url: this.verifiers + "/recovery/initiate",
      params: {context: networkId},
      body: data
    }).then(function() {
      return true;
    }).catch(function(response) {
      return response.data;
    });
  }

  submitVerifiedUser(userId: string, code: string) {
    const data = {'recoveryUser': userId, 'code': code};
    return this.send({
      method: 'POST',
      url: this.verifiers + "/recovery/verify",
      body: data
    }).then(function() {
      return true;
    }).catch(function(response) {
      return response.data;
    });
  }
}
